import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/index.css";
import App from "@/App";
import FeedbackForm from "@/pages/FeedbackForm";
import { Toaster } from "sonner";
import { AuthProvider } from "@/contexts/AuthContext";

// Disable default right-click (custom context menus on staff rows still work via Radix)
document.addEventListener("contextmenu", (e) => {
  if (!e.target.closest("[data-radix-collection-item]") && !e.target.closest("[role='menuitem']")) {
    e.preventDefault();
  }
});

// Block common DevTools shortcuts
document.addEventListener("keydown", (e) => {
  if (e.key === "F12") { e.preventDefault(); return; }
  if (e.ctrlKey && e.shiftKey && ["I","i","J","j","C","c"].includes(e.key)) { e.preventDefault(); return; }
  if (e.ctrlKey && ["U","u"].includes(e.key)) { e.preventDefault(); return; }
});

// Anti-inspect: detect DevTools via window outer/inner size difference
// and debugger trap to freeze Elements panel.
//
// IMPORTANT: skip on touch / small-viewport devices. Mobile browsers' URL bar
// and bottom toolbar cause outerHeight − innerHeight to exceed the threshold
// naturally, which would otherwise nuke the DOM and show a black screen.
(function() {
  const isTouchDevice =
    ("ontouchstart" in window) ||
    (navigator.maxTouchPoints && navigator.maxTouchPoints > 0) ||
    window.matchMedia("(pointer: coarse)").matches ||
    window.innerWidth < 900;
  if (isTouchDevice) return;

  const threshold = 160;
  let devtoolsOpen = false;
  const check = () => {
    const widthDiff = window.outerWidth - window.innerWidth > threshold;
    const heightDiff = window.outerHeight - window.innerHeight > threshold;
    if (widthDiff || heightDiff) {
      if (!devtoolsOpen) {
        devtoolsOpen = true;
        while (document.body.firstChild) document.body.removeChild(document.body.firstChild);
        document.body.style.background = '#0A0A0A';
      }
    } else {
      devtoolsOpen = false;
    }
  };
  setInterval(check, 1000);

  // Debugger trap — freezes execution when Elements panel is open
  (function trap() {
    const start = performance.now();
    // eslint-disable-next-line no-debugger
    debugger;
    if (performance.now() - start > 100) {
      while (document.body.firstChild) document.body.removeChild(document.body.firstChild);
      document.body.style.background = '#0A0A0A';
    }
    setTimeout(trap, 4000);
  })();

  // Block drag/select to prevent easy text copying
  document.addEventListener("selectstart", (e) => {
    if (e.target.tagName !== "INPUT" && e.target.tagName !== "TEXTAREA") {
      e.preventDefault();
    }
  });
  document.addEventListener("dragstart", (e) => e.preventDefault());
})();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<App />} />
          <Route path="/feedback" element={<FeedbackForm />} />
        </Routes>
        <Toaster 
        position="top-right" 
        toastOptions={{
          style: {
            background: "#121212",
            border: "1px solid #27272A",
            color: "#F4F4F5",
            borderRadius: "0",
            fontFamily: "'JetBrains Mono', monospace",
            fontSize: "0.75rem"
          }
        }}
      />
      </BrowserRouter>
    </AuthProvider>
  </React.StrictMode>,
);
